<template>
  <div class="login-container">
    <h2>Autentificare O.S.A.C.E.</h2>

    <form @submit.prevent="handleLogin">

      <div class="form-group">
        <label for="email">Email:</label>
        <input type="email" id="email" v-model="email" required />
      </div>

      <div class="form-group">
        <label for="password">Parolă:</label>
        <input type="password" id="password" v-model="password" required />
      </div>

      <button type="submit">Login</button>
    </form>

    <p v-if="message" class="message">{{ message }}</p>

    <div class="switch-form">
      <router-link to="/register">Nu ai un cont? Înregistrează-te</router-link>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router'; // 1. Asigură-te că folosești useRouter
import apiClient from '@/api.js';

const email = ref('');
const password = ref('');
const message = ref('');

const router = useRouter(); // 2. Inițializează router-ul

const handleLogin = async () => {
  try {
    message.value = 'Se trimite...';
    
    // --- PRIMUL PAS: Obținem token-ul ---
    const response = await apiClient.post('/auth/login', {
      email: email.value,
      password: password.value
    });
    
    // 3. SALVĂM TOKEN-UL
    localStorage.setItem('userToken', response.data.token);

    // --- PASUL CRITIC (CARE PROBABIL LIPSEȘTE) ---
    // 4. Facem un al doilea apel pentru a prelua datele user-ului
    const profileResponse = await apiClient.get('/profile/me');
    
    // 5. SALVĂM DATELE USER-ULUI (inclusiv rolul)
    localStorage.setItem('user', JSON.stringify(profileResponse.data));
    // --- SFÂRȘITUL BLOCULUI CRITIC ---

    message.value = 'Autentificare reușită! Se încarcă profilul...';
    
    // 6. Redirecționăm cu router-ul (NU cu window.location.reload)
    router.push({ path : '/', replace: true }); 

  } catch (error) {
    console.error('Eroare la login:', error);
    message.value = `Eroare: ${error.response?.data?.error || 'A apărut o eroare'}`;
    // Curățăm tot în caz de eroare
    localStorage.removeItem('userToken');
    localStorage.removeItem('user');
  }
};
</script>

<style scoped>
/* Am revenit la stilurile CSS originale */
.login-container {
  border: 1px solid #ccc;
  padding: 20px;
  border-radius: 8px;
}
.form-group {
  margin-bottom: 15px;
}
.form-group label {
  display: block;
  margin-bottom: 5px;
}
.form-group input {
  width: 100%;
  padding: 8px;
  box-sizing: border-box; /* Asigură că padding-ul nu strică lățimea */
}
button {
  background-color: #007bff;
  color: white;
  padding: 10px 15px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
button:hover {
  background-color: #0056b3;
}
.message {
  margin-top: 15px;
  color: red; /* Implicit roșu pentru erori */
}
.switch-form {
  margin-top: 20px;
  text-align: center;
}
</style>